@if (user) {
  <div class="name" #userMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="userMenu">
    <i class="fa-solid fa-user"></i>
  </div>
}

<mat-menu #userMenu="matMenu">
  <div class="menu-text">
    <div class="text-x-small">
      {{userFullName}}
    </div>
    <div class="text-tiny">
      {{user?.email}}
    </div>
  </div>

  @if (languages && languages.length > 0) {
    <button mat-menu-item [matMenuTriggerFor]="changeLanguage">
      <mat-icon>language</mat-icon> <span translate>Change language</span>
    </button>
  }

  <button mat-menu-item (click)="onLogout()">
    <mat-icon>exit_to_app</mat-icon>
    <span translate>Logout</span>
  </button>
</mat-menu>

<!-- submenu for change language -->
<mat-menu #changeLanguage="matMenu">
  @for (lang of languages; track lang) {
    <button mat-menu-item (click)="selectLanguage(lang)">
      {{languageName(lang)}}
    </button>
  }
</mat-menu>